import React from 'react';
import PropTypes from 'prop-types';
import IgnoredStoreService from "../../Services/IgnoredStoreService";
import SupplementalStoresTable from "../../Configurations/SupplementalStoresTable";
import {StoreClosuresForRetailer} from "../../Configurations/StoreClosuresForRetailer";
import RetailerStores from "../RetailerStores";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import UnmappedStores from "../../Unmapped/UnmappedStores";

export const StoresTab = ({retailChain, retailerId}) => {
    return (
        <Tabs>
            <TabList>
                <Tab data-testid={"retailerStores-tab-name"}>Store Info</Tab>
                <Tab data-testid={"ignoredStoreService-tab-name"}>Ignored</Tab>
                <Tab data-testid={"supplementalStoresTable-tab-name"}>Supplemental</Tab>
                <Tab data-testid={"storeClosuresForRetailer-tab-name"}>Closures</Tab>
            </TabList>
            <TabPanel data-testid={"retailerStores-tab-panel"}>
                <RetailerStores retailerId={retailerId}/>
                <div>
                    <UnmappedStores retailerId={retailerId} retailChain={retailChain} displayHelmetHeader={false} />
                </div>
            </TabPanel>
            <TabPanel data-testid={"ignoredStoreService-tab-panel"}><IgnoredStoreService retailerId={retailerId} displayHelmetHeader={false}/></TabPanel>
            <TabPanel data-testid={"supplementalStoresTable-tab-panel"}><SupplementalStoresTable retailerId={retailerId} displayHelmetHeader={false}/></TabPanel>
            <TabPanel data-testid={"storeClosuresForRetailer-tab-panel"}><StoreClosuresForRetailer retailerId={retailerId}/></TabPanel>
        </Tabs>
    )
};


StoresTab.propTypes = {
    retailChain: PropTypes.string.isRequired,
    retailerId: PropTypes.number.isRequired
};